import domain from './domain';

// Reset payment methods
export const resetPaymentMethods = domain.createEvent('resetPaymentMethods');
